import { HttpService, Repository, RepositoryBase, TaggedUrl, Tags, Weaver } from '@skylab-shared/core';
import { OssVatRateModel } from '@skylab-shared/dataModel';
import { pickBy } from '@skylab-shared/utils';
import { OssVatRateBO } from './oss-vat-rate.bo';


@Repository({
    boType: OssVatRateBO,
    apiController: TaggedUrl.join('sales/vatRates', [Tags.Api])
})
export class OssVatRateRepositoryBase extends RepositoryBase<OssVatRateBO, OssVatRateModel> {
    public constructor(
        http: HttpService,
        private readonly weaver: Weaver
    ) {
        super(http);
    }

    protected createBO(): OssVatRateBO {
        return new OssVatRateBO(this.weaver);
    }

    protected async preparePlainObjectAsync(model: OssVatRateModel): Promise<any> {
        return {
            id: model.id,
            sun: model.sun,
            version: model.version,

            default: model.default,
            rate: model.rate,
            name: model.name,
            countryId: model.countryId,
            symbol: model.symbol,
            active: model.active,
            inUse: model.inUse,
            externalId: model.externalId
        };
    }

    protected async fromPlainObjectAsync(item: any): Promise<OssVatRateModel> {
        return new OssVatRateModel(pickBy({
            id: item.id,
            sun: item.sun,
            version: item.version,

            default: item.default,
            rate: item.rate,
            name: item.name,
            countryId: item.countryId,
            symbol: item.symbol,
            active: item.active,
            inUse: item.inUse,
            externalId: item.externalId
        }, val => val !== void 0));
    }
}
